import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { isValidEmail } from 'src/clinic/views/onboardng/clinicBrand/components/utils'
import {
  APP_CONSTANTS,
  PUBLIC_HOMEPAGE_FOUR_CARD_DESIGN_LANDSCAPE_DATA,
  PUBLIC_HOMEPAGE_FOUR_CARD_DESIGN_PORTRAIT_DATA,
} from 'src/consumer/constants'
import { SEOComponent } from 'src/consumer/helpers/utilFunctions'
import {
  selectOneOnOneMentorsData,
  setOneOnOneMentorsData,
} from 'src/consumer/reducers/genericData/genericDataReducer'
import { getDataPublic } from 'src/consumer/services/profileService'
import {
  ActionButtonForCWBVO,
  AppDownloadComponent,
  CarouselWithButtonsVariantOne,
  FourCardsOptionsVariantOne,
  HeadingAndDescriptionForCWBVO,
  MobileScreenshotComponentForCWBVO,
  ShadeBackgroundForPublicPagesVariantOne,
} from '../ListingPageComponentsAndHelpers/ListingPageComponents'
import { FindTherapistSection } from './FindTherapistSection'
import { PublicAppFooter } from '../PublicAppFooter'
import PublicAppHeader from '../PublicAppHeader'
import { ClubbedAuthModal } from '../SignIn/ClubbedAuthComponents'

export function PublicAppHomepage() {
  const oneOnOneMentorsData = useSelector(selectOneOnOneMentorsData)
  const dispatch = useDispatch()
  const urlParams = new URLSearchParams(window.location.search)
  const redirectUri = urlParams.get('redirect')
  const loginUserNameFromParams = urlParams.get('loginUserName')
  const loginTrue = urlParams.get('lt')
  const isWhatsAppLogin = loginTrue === 'w'

  const [showClubbedAuthModal, setShowClubbedAuthModal] = useState(false)
  const [typeOfClubbedAuthModal, setTypeOfClubbedAuthModal] = useState('login')

  async function getAndDispatchOneOnOneData() {
    const response = await getDataPublic('/api/external/mentor/1on1/list')
    if (response?.status === 200) {
      dispatch(setOneOnOneMentorsData(response?.data))
    }
  }

  useEffect(() => {
    getAndDispatchOneOnOneData()
  }, [])

  useEffect(() => {
    if (urlParams?.has('redirect')) {
      setShowClubbedAuthModal(true)
      setTypeOfClubbedAuthModal('login')
    }
    if (loginUserNameFromParams) {
      setShowClubbedAuthModal(true)
    } else if (loginTrue) {
      setShowClubbedAuthModal(true)
    }
  }, [])

  const therapists = oneOnOneMentorsData?.filter((item) => item?.categories?.includes('therapist'))

  return (
    <>
      <SEOComponent
        title={APP_CONSTANTS.DEFAULT_TITLE}
        description={APP_CONSTANTS.DEFAULT_DESCRIPTION}
        image={APP_CONSTANTS.APP_LOGO_LINK}
      />
      <PublicAppHeader
        config={{ showLinks: true }}
        loginFunction={() => {
          setTypeOfClubbedAuthModal('login')
          setShowClubbedAuthModal(true)
        }}
        registerFunction={() => {
          setTypeOfClubbedAuthModal('signup')
          setShowClubbedAuthModal(true)
        }}
      />
      <ClubbedAuthModal
        open={showClubbedAuthModal}
        onClose={() => setShowClubbedAuthModal(false)}
        preferredLoginInputType={
          isValidEmail(loginUserNameFromParams)
            ? 'email'
            : loginTrue
              ? (isWhatsAppLogin ? 'whatsapp' : 'mobile')
              : undefined
        } // mobile, email, whatsapp
        preferredLoginInputValue={
          loginUserNameFromParams
            ? isValidEmail(loginUserNameFromParams)
              ? loginUserNameFromParams
              : String(loginUserNameFromParams)
            : null
        } // must be string of type '+9105..' or '9105..'
        loginVariant={typeOfClubbedAuthModal === 'login'}
        loginFieldHeading={redirectUri ? 'Please login to continue' : undefined}
        redirectToURI={redirectUri}
      />
      <ShadeBackgroundForPublicPagesVariantOne />
      <FourCardsOptionsVariantOne
        dataLandscapeCards={PUBLIC_HOMEPAGE_FOUR_CARD_DESIGN_LANDSCAPE_DATA}
        dataPortraitCards={PUBLIC_HOMEPAGE_FOUR_CARD_DESIGN_PORTRAIT_DATA}
      />
      <CarouselWithButtonsVariantOne
        backgroundColor={'#efeadd'}
        gradientColor="linear-gradient(
          90deg,
          rgba(239, 234, 221, 0) 85%,
          rgba(239, 234, 221, 0.4) 95%,
          rgba(239, 234, 221, 0.9) 100%
        );"
        buttonColor={'#000'}
        heightProp="550"
        componentOne={
          <HeadingAndDescriptionForCWBVO
            headingText="Get clear guidance on your Mental Health, Wellness, and Fitness."
            descriptionText=""
            textColor="#000"
          />
        }
        StackComponent={MobileScreenshotComponentForCWBVO}
        itemsForStack={[
          'MEDIA-18b118a045ed4efa9870cb1577977751',
          'MEDIA-d689f0ba33d242fa86a1ad942a77492b',
          'MEDIA-71d30b9670d04a8d98b77f8a13bbe44f',
          'MEDIA-d8564ee7ecf94ff2bb3a34c77556e199',
          'MEDIA-2f17e89af0eb44cdb0562b78661c85a4',
          // 'MEDIA-bb55588e2e8e45b0acb00f075c61bc0e',
        ]}
        componentTwo={
          <ActionButtonForCWBVO
            text="Find your Mentor"
            color="#000"
            hoverBackground="#000"
            hoverColor="#fff"
            linkTo="/therapy-psychiatry"
          />
        }
      />
      <AppDownloadComponent />
      <FindTherapistSection therapists={therapists} />
      <PublicAppFooter />
    </>
  )
}

// {/* <TestimonialSection
// direction="LTR"
// testimonials={[
//   {
//     profilePic: 'https://en.pimg.jp/104/546/933/1/104546933.jpg',
//     handle: '@johndoe',
//     name: 'John Doe',
//     quote: 'This tool is amazing!',
//     logo: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAAAAABXZoBIAAAA/0lEQVR4AbXPIazCMACE4d+L2qoZFEGSIGcRc/gJJB5XMzGJmK9EN0HMi+qaibkKVF1txdQe4g0YzPK5yyWXHL9TaPNQ89LojH87N1rbJcXkMF4Fk31UMrf34hm14KUeoQxGArALHTMuQD2cAWQfJXOpgTbksGr9ng8qluShJTPhyCdx63POg7rEim95ZyR68I1ggQpnCEGwyPicw6hZtPEGmnhkycqOio1zm6XuFtyw5XDXfGvuau0dXHzJp8pfBPuhIXO9ZK5ILUCdSvLYMpc6ASBtl3EaC97I4KaFaOCaBE9Zn5jUsVqR2vcTJZO1DdbGoZryVp94Ka/mQfE7f2T3df0WBhLDAAAAAElFTkSuQmCC',
//   },
//   {
//     profilePic: 'https://wallpapers.com/images/high/cartoon-pictures-3dte0pf467umwgmc.webp',
//     handle: '@janesmith',
//     name: 'Jane Smith',
//     quote: 'Helped me save my time.',
//     logo: 'https://img.freepik.com/free-vector/instagram-vector-social-media-icon-7-june-2021-bangkok-thailand_53876-136728.jpg?w=996&t=st=1720670828~exp=1720671428~hmac=98596efe2bae59535eae78a6763b79a530f086f65f78df5ab78d7c7c21b8eecf',
//   },
//   {
//     profilePic:
//       'https://images.saymedia-content.com/.image/c_limit%2Ccs_srgb%2Cq_auto:eco%2Cw_700/MTc0MjM5Mzg5NDE1NjQ2NzE2/how-to-draw-yoda.webp',
//     handle: '@MasterYoda',
//     name: 'Yoda',
//     quote: 'my mental health this app made better',
//     logo: 'https://1000logos.net/wp-content/uploads/2016/11/fb-logo.jpg',
//   },
//   {
//     profilePic: 'https://en.pimg.jp/104/546/933/1/104546933.jpg',
//     handle: '@johndoe',
//     name: 'John Doe',
//     quote: 'This tool is amazing!',
//     logo: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAAAAABXZoBIAAAA/0lEQVR4AbXPIazCMACE4d+L2qoZFEGSIGcRc/gJJB5XMzGJmK9EN0HMi+qaibkKVF1txdQe4g0YzPK5yyWXHL9TaPNQ89LojH87N1rbJcXkMF4Fk31UMrf34hm14KUeoQxGArALHTMuQD2cAWQfJXOpgTbksGr9ng8qluShJTPhyCdx63POg7rEim95ZyR68I1ggQpnCEGwyPicw6hZtPEGmnhkycqOio1zm6XuFtyw5XDXfGvuau0dXHzJp8pfBPuhIXO9ZK5ILUCdSvLYMpc6ASBtl3EaC97I4KaFaOCaBE9Zn5jUsVqR2vcTJZO1DdbGoZryVp94Ka/mQfE7f2T3df0WBhLDAAAAAElFTkSuQmCC',
//   },
//   {
//     profilePic: 'https://wallpapers.com/images/high/cartoon-pictures-3dte0pf467umwgmc.webp',
//     handle: '@janesmith',
//     name: 'Jane Smith',
//     quote: 'Helped me save my time.',
//     logo: 'https://img.freepik.com/free-vector/instagram-vector-social-media-icon-7-june-2021-bangkok-thailand_53876-136728.jpg?w=996&t=st=1720670828~exp=1720671428~hmac=98596efe2bae59535eae78a6763b79a530f086f65f78df5ab78d7c7c21b8eecf',
//   },
//   {
//     profilePic:
//       'https://images.saymedia-content.com/.image/c_limit%2Ccs_srgb%2Cq_auto:eco%2Cw_700/MTc0MjM5Mzg5NDE1NjQ2NzE2/how-to-draw-yoda.webp',
//     handle: '@MasterYoda',
//     name: 'Yoda',
//     quote: 'my mental health this app made better',
//     logo: 'https://1000logos.net/wp-content/uploads/2016/11/fb-logo.jpg',
//   },
//   {
//     profilePic: 'https://en.pimg.jp/104/546/933/1/104546933.jpg',
//     handle: '@johndoe',
//     name: 'John Doe',
//     quote: 'This tool is amazing!',
//     logo: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAAAAABXZoBIAAAA/0lEQVR4AbXPIazCMACE4d+L2qoZFEGSIGcRc/gJJB5XMzGJmK9EN0HMi+qaibkKVF1txdQe4g0YzPK5yyWXHL9TaPNQ89LojH87N1rbJcXkMF4Fk31UMrf34hm14KUeoQxGArALHTMuQD2cAWQfJXOpgTbksGr9ng8qluShJTPhyCdx63POg7rEim95ZyR68I1ggQpnCEGwyPicw6hZtPEGmnhkycqOio1zm6XuFtyw5XDXfGvuau0dXHzJp8pfBPuhIXO9ZK5ILUCdSvLYMpc6ASBtl3EaC97I4KaFaOCaBE9Zn5jUsVqR2vcTJZO1DdbGoZryVp94Ka/mQfE7f2T3df0WBhLDAAAAAElFTkSuQmCC',
//   },
//   {
//     profilePic: 'https://wallpapers.com/images/high/cartoon-pictures-3dte0pf467umwgmc.webp',
//     handle: '@janesmith',
//     name: 'Jane Smith',
//     quote: 'Helped me save my time.',
//     logo: 'https://img.freepik.com/free-vector/instagram-vector-social-media-icon-7-june-2021-bangkok-thailand_53876-136728.jpg?w=996&t=st=1720670828~exp=1720671428~hmac=98596efe2bae59535eae78a6763b79a530f086f65f78df5ab78d7c7c21b8eecf',
//   },
//   {
//     profilePic:
//       'https://images.saymedia-content.com/.image/c_limit%2Ccs_srgb%2Cq_auto:eco%2Cw_700/MTc0MjM5Mzg5NDE1NjQ2NzE2/how-to-draw-yoda.webp',
//     handle: '@MasterYoda',
//     name: 'Yoda',
//     quote: 'my mental health this app made better',
//     logo: 'https://1000logos.net/wp-content/uploads/2016/11/fb-logo.jpg',
//   },
// ]}
// />

// <TestimonialSection
// direction="RTL"
// testimonials={[
//   {
//     profilePic:
//       'https://images.saymedia-content.com/.image/c_limit%2Ccs_srgb%2Cq_auto:eco%2Cw_700/MTc0MjM5Mzg5NDE1NjQ2NzE2/how-to-draw-yoda.webp',
//     handle: '@MasterYoda',
//     name: 'Yoda',
//     quote: 'my mental health this app made better',
//     logo: 'https://1000logos.net/wp-content/uploads/2016/11/fb-logo.jpg',
//   },
//   {
//     profilePic: 'https://en.pimg.jp/104/546/933/1/104546933.jpg',
//     handle: '@johndoe',
//     name: 'John Doe',
//     quote: 'This tool is amazing!',
//     logo: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAAAAABXZoBIAAAA/0lEQVR4AbXPIazCMACE4d+L2qoZFEGSIGcRc/gJJB5XMzGJmK9EN0HMi+qaibkKVF1txdQe4g0YzPK5yyWXHL9TaPNQ89LojH87N1rbJcXkMF4Fk31UMrf34hm14KUeoQxGArALHTMuQD2cAWQfJXOpgTbksGr9ng8qluShJTPhyCdx63POg7rEim95ZyR68I1ggQpnCEGwyPicw6hZtPEGmnhkycqOio1zm6XuFtyw5XDXfGvuau0dXHzJp8pfBPuhIXO9ZK5ILUCdSvLYMpc6ASBtl3EaC97I4KaFaOCaBE9Zn5jUsVqR2vcTJZO1DdbGoZryVp94Ka/mQfE7f2T3df0WBhLDAAAAAElFTkSuQmCC',
//   },
//   {
//     profilePic: 'https://wallpapers.com/images/high/cartoon-pictures-3dte0pf467umwgmc.webp',
//     handle: '@janesmith',
//     name: 'Jane Smith',
//     quote: 'Helped me save my time.',
//     logo: 'https://img.freepik.com/free-vector/instagram-vector-social-media-icon-7-june-2021-bangkok-thailand_53876-136728.jpg?w=996&t=st=1720670828~exp=1720671428~hmac=98596efe2bae59535eae78a6763b79a530f086f65f78df5ab78d7c7c21b8eecf',
//   },
//   {
//     profilePic:
//       'https://images.saymedia-content.com/.image/c_limit%2Ccs_srgb%2Cq_auto:eco%2Cw_700/MTc0MjM5Mzg5NDE1NjQ2NzE2/how-to-draw-yoda.webp',
//     handle: '@MasterYoda',
//     name: 'Yoda',
//     quote: 'my mental health this app made better',
//     logo: 'https://1000logos.net/wp-content/uploads/2016/11/fb-logo.jpg',
//   },
//   {
//     profilePic: 'https://en.pimg.jp/104/546/933/1/104546933.jpg',
//     handle: '@johndoe',
//     name: 'John Doe',
//     quote: 'This tool is amazing!',
//     logo: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAAAAABXZoBIAAAA/0lEQVR4AbXPIazCMACE4d+L2qoZFEGSIGcRc/gJJB5XMzGJmK9EN0HMi+qaibkKVF1txdQe4g0YzPK5yyWXHL9TaPNQ89LojH87N1rbJcXkMF4Fk31UMrf34hm14KUeoQxGArALHTMuQD2cAWQfJXOpgTbksGr9ng8qluShJTPhyCdx63POg7rEim95ZyR68I1ggQpnCEGwyPicw6hZtPEGmnhkycqOio1zm6XuFtyw5XDXfGvuau0dXHzJp8pfBPuhIXO9ZK5ILUCdSvLYMpc6ASBtl3EaC97I4KaFaOCaBE9Zn5jUsVqR2vcTJZO1DdbGoZryVp94Ka/mQfE7f2T3df0WBhLDAAAAAElFTkSuQmCC',
//   },
//   {
//     profilePic: 'https://wallpapers.com/images/high/cartoon-pictures-3dte0pf467umwgmc.webp',
//     handle: '@janesmith',
//     name: 'Jane Smith',
//     quote: 'Helped me save my time.',
//     logo: 'https://img.freepik.com/free-vector/instagram-vector-social-media-icon-7-june-2021-bangkok-thailand_53876-136728.jpg?w=996&t=st=1720670828~exp=1720671428~hmac=98596efe2bae59535eae78a6763b79a530f086f65f78df5ab78d7c7c21b8eecf',
//   },

//   {
//     profilePic:
//       'https://images.saymedia-content.com/.image/c_limit%2Ccs_srgb%2Cq_auto:eco%2Cw_700/MTc0MjM5Mzg5NDE1NjQ2NzE2/how-to-draw-yoda.webp',
//     handle: '@MasterYoda',
//     name: 'Yoda',
//     quote: 'my mental health this app made better',
//     logo: 'https://1000logos.net/wp-content/uploads/2016/11/fb-logo.jpg',
//   },
// ]}
// /> */}
